import { useAccountMargin } from './useAccountMargin';
import { useAccountUPnl } from './useAccountUPnl';

export const useAccountEquity = () => {
  const { data: accountUPnl } = useAccountUPnl();
  const { data: marginData } = useAccountMargin();
  return marginData ? marginData.totalBalance + (accountUPnl || 0n) : undefined;
};
